<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">chat</v-icon> {{ $t('chat.title') }} / <strong>{{cubiculo.identificador}}</strong></h3>
      <v-layout wrap>
        <v-flex sm3 md2>
          <div class="conversation-container-users">
          <v-card>
            <v-card-text>
              <v-tooltip color="primary" top>
                <v-btn icon color="info" slot="activator" @click="seleccionarVarios">
                  <v-icon>{{icon}}</v-icon>
                </v-btn>
                <span>Seleccionar Varios</span>
              </v-tooltip>
              <v-btn color="success" v-for="(canal_comunicacion, index) in cubiculo.canales_autorizados" v-bind:key="index" v-if="canal_comunicacion.clasificacion == 'llamada'" @click="abrirCanal(canal_comunicacion)">
                <v-icon small>phone</v-icon> {{canal_comunicacion.usuario}}
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-form>
                    <v-text-field
                      v-model="filtro"
                      label="Filtrar"
                      placeholder="Escriba aquí..."
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card v-for="(conectado, index) in conectados" v-bind:key="index" v-bind:class="{'warning':(conectado.id === usuario.id)}" v-if="filtro.length === 0">
            <v-card-text @click="iniciarConversacion(conectado)">
              <div class="user-connected" v-bind:class="conectado.clasificacion">
                <v-layout row wrap>
                  <v-flex xs11>
                    <img :src="imagenCanal(conectado.clasificacion)" class="icono-canal"/>
                    <span class="username" v-if="conectado.persona.id > 0">{{conectado.persona.nombres}} {{conectado.persona.primer_apellido}} {{conectado.persona.segundo_apellido}}</span>
                    <span class="username" v-else>
                      <span v-if="conectado.clasificacion === 'correo'">{{conectado.usuario}}</span>
                      <span v-else>{{conectado.usuario.split('@')[0]}}</span>
                    </span>
                    <span class="metadata">
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'texto'">{{textoCorto(conectado.mensaje.contenido)}}</span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'audio'"><v-icon small>mic</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'archivo'"><v-icon small>attach_file</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'imagen'"><v-icon small>collections</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'email'"><v-icon small>mail</v-icon>{{conectado.mensaje.extras.asunto}}</span>
                      <span class="time">{{formato(conectado.mensaje._created_at)}}</span>
                    </span>
                  </v-flex>
                  <v-flex xs1>
                    <div class="chat-acciones">
                        <v-btn icon color="bubble" class="bubble" v-if="conectado.mensaje.total > 0 && conectado.id !== usuario.id">
                          <span>{{conectado.mensaje.total}}</span>
                        </v-btn>
                        <v-tooltip color="primary" right>
                          <v-btn slot="activator" flat icon color="primary" @click.native.stop="seleccionarCanal(conectado)">
                            <v-icon>{{conectado.seleccion}}</v-icon>
                          </v-btn>
                          <span>Seleccionar</span>
                        </v-tooltip>
                        <v-tooltip color="red" right>
                          <v-btn slot="activator" flat icon color="red" @click.native.stop="cerrarCanal(index)">
                            <v-icon>clear</v-icon>
                          </v-btn>
                          <span>Quitar</span>
                        </v-tooltip>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
          <v-card v-for="(conectado, index) in filtrados" v-bind:key="index" v-bind:class="{'warning':(conectado.id === usuario.id)}" v-if="filtro.length > 0">
            <v-card-text @click="iniciarConversacion(conectado)">
              <div class="user-connected" v-bind:class="conectado.clasificacion">
                <v-layout row wrap>
                  <v-flex xs11>
                    <img :src="imagenCanal(conectado.clasificacion)" class="icono-canal"/>
                    <span class="username" v-if="conectado.persona.id > 0">{{conectado.persona.nombres}} {{conectado.persona.primer_apellido}} {{conectado.persona.segundo_apellido}}</span>
                    <span class="username" v-else>
                      <span v-if="conectado.clasificacion === 'correo'">{{conectado.usuario}}</span>
                      <span v-else>{{conectado.usuario.split('@')[0]}}</span>
                    </span>
                    <span class="metadata">
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'texto'">{{textoCorto(conectado.mensaje.contenido)}}</span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'audio'"><v-icon small>mic</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'archivo'"><v-icon small>attach_file</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'imagen'"><v-icon small>collections</v-icon></span>
                      <span class="usertext" v-if="conectado.mensaje.tipo_contenido === 'email'"><v-icon small>mail</v-icon>{{conectado.mensaje.extras.asunto}}</span>
                      <span class="time">{{formato(conectado.mensaje._created_at)}}</span>
                    </span>
                  </v-flex>
                  <v-flex xs1>
                    <div class="chat-acciones">
                        <v-btn icon color="bubble" class="bubble" v-if="conectado.mensaje.total > 0 && conectado.id !== usuario.id">
                          <span>{{conectado.mensaje.total}}</span>
                        </v-btn>
                        <v-tooltip color="primary" right>
                          <v-btn slot="activator" flat icon color="primary" @click.native.stop="seleccionarCanal(conectado)">
                            <v-icon>{{conectado.seleccion}}</v-icon>
                          </v-btn>
                          <span>Seleccionar</span>
                        </v-tooltip>
                        <v-tooltip color="red" right>
                          <v-btn slot="activator" flat icon color="red" @click.native.stop="cerrarCanal(index)">
                            <v-icon>clear</v-icon>
                          </v-btn>
                          <span>Quitar</span>
                        </v-tooltip>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
          </div>
        </v-flex>
        <v-flex sm9 md10>
          <v-card flat outlined elevation="1" v-if="!usuario.id && seleccionados <= 0" style="min-height: 100%;">
            <v-card-text>
              <v-alert
                color="info"
                :value="true" >
                <div class="text-xs-justify">
                  <p><v-icon>info</v-icon> Debe seleccionar UNO o VARIOS (<v-icon color="white" small>check_box</v-icon>) canales de entrada en el panel izquierdo.</p>
                </div>
              </v-alert>
            </v-card-text>
          </v-card>

          <editor :enviado="this.enviado" :exito="this.exito" @archivos="archivosSeleccionados" @mensaje="mensajeEnvio" @enviar="enviarMensaje" v-if="seleccionados > 0"></editor>
          <chat-usuario v-if="usuario.id > 0" :key="chatKey" :cubiculo="cubiculo.id" :canal="usuario.id" @recuperar="recuperarPersona" @adjuntado="casoAdjuntado" @derivar="casoDerivado"></chat-usuario>
        </v-flex>
      </v-layout>
      <v-dialog :key="dialogCasoKey" v-model="dialogCaso" max-width="700">
        <v-card>
          <v-card-title class="headline m-0">
            <v-flex xs12>
              <v-icon>phone</v-icon> Iniciar Caso
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-text-field
                label="Número de teléfono"
                v-model="caso.usuario"
                maxlength="8"
                :rules="$validate(['required','phone'])"
                required
                class="required"
                ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                name="descripcion"
                label="Descripción"
                id="descripcion"
                v-model="caso.descripcion"
                maxlength="200"
                :rules="$validate(['required'])"
                counter
                required
              ></v-textarea>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
            <v-spacer></v-spacer>
            <v-btn
              @click.native="dialogCaso = false">
              <v-icon>cancel</v-icon> {{$t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              @click.native="guardarCaso"
              :disabled="(!caso.usuario || caso.usuario == '') || (!caso.descripcion || caso.descripcion == '') || caso.usuario.length != 8">
              <v-icon>check</v-icon> {{$t('common.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </section>
</template>
<script>
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import moment from 'moment';
import ChatUsuario from '@/components/admin/operadores/ChatUsuario';
import Editor from '@/common/plugins/editor/Editor.vue';

var socket = require('socket.io-client');
var io = null;
window.onbeforeunload = function (e) {
  if (io) {
    io.emit('end');
  }
};
export default {
  mixins: [validate, token],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.id = this.$route.params.id;
    this.recuperarPuntoAtencion();
    io = socket.connect(process.env.SOCKET_URL, {
      'query': `token=${this.$storage.get('token')}`,
      'path': `${process.env.SOCKET_PATH}`
    });
    io.on('connect', (data) => {

    });
    io.on('error', function (error) {
      if (error.type === 'UnauthorizedError' || error.code === 'invalid_token') {
        // redirect user to login page perhaps?
      }
    });
  },
  beforeDestroy () {
    io.emit('end');
    if (this.interval != null) {
      clearInterval(this.interval);
    }
  },
  mounted () {
    if (`${this.$storage.get('cubiculo')}` !== `${this.$route.params.id}`) {
      this.$router.push(`/puntos-atencion`);
    }

    io.emit('conectado', {id: this.$route.params.id});
    io.on('conectado', (data) => {
      this.interval = setInterval((item) => {
        io.emit('usuarios', {id: this.$route.params.id, ultima_conversacion: this.ultima_conversacion});
      }, 1000);
    });
    io.on('iniciado', (data) => {
      this.conectado = true;
    });
    io.on('nuevo usuario', (data) => {
      if (data && data.length > 0) {
        data.forEach((_item) => {
          let buscar = this.conectados.findIndex(item => (item.id === _item.id) || (_item.id_persona && item.id_persona === _item.id_persona));
          if (buscar < 0) {
            _item.seleccion = 'check_box_outline_blank';
            this.conectados.push(_item);
            if (this.caso.id === _item.mensaje.id_caso) {
              this.iniciarConversacion(_item);
            }
          } else {
            if (this.conectados[buscar].mensaje.id < _item.mensaje.id) {
              // this.conectados[buscar] = _item;
              this.conectados[buscar].clasificacion = _item.clasificacion;
              this.conectados[buscar].mensaje.contenido = _item.mensaje.contenido;
              this.conectados[buscar].mensaje.tipo_contenido = _item.mensaje.tipo_contenido;
              this.conectados[buscar].mensaje.id_caso = _item.mensaje.id_caso;
              this.conectados[buscar].mensaje.total += _item.mensaje.total;
              this.conectados[buscar].mensaje.id = _item.mensaje.id;
            }
          }
          if (_item.mensaje.id > this.ultima_conversacion) this.ultima_conversacion = _item.mensaje.id;
        });
      }
    });
  },
  data () {
    return {
      interval: null,
      conectado: false,
      usuario: {id: null},
      cubiculo: {},
      conectados: [],
      ultima_conversacion: 0,
      tramites: [],
      respuestas: [],
      casoForm: {},
      validCaso: true,
      chatKey: 'chat-usuario',
      dialogCaso: false,
      dialogCasoKey: 'dialogo-resumen',
      validarCaso: false,
      caso: {},
      canal_comunicacion_seleccionado: 0,
      icon: 'check_box_outline_blank',
      varios: false,
      seleccionados: 0,
      canales: [],
      enviado: true,
      exito: false,
      archivos: [],
      mensaje: '',
      filtro: '',
      filtrados: []
    };
  },
  watch: {
    'varios' () {
      if (this.filtro.length === 0) {
        let buscar = this.conectados.filter(item => item.seleccion === 'check_box');
        this.seleccionados = buscar.length;
        this.canales = [];
        if (this.seleccionados > 0) {
          this.usuario = {id: null};
          buscar.forEach((item) => {
            this.canales.push({canal: item.id, id_caso: item.mensaje.id_caso});
          });
        }
        if (buscar.length === 0) {
          this.icon = 'check_box_outline_blank';
        } else if (buscar.length === this.conectados.length) {
          this.icon = 'check_box';
        } else {
          this.icon = 'indeterminate_check_box';
        }
      } else {
        let buscar = this.filtrados.filter(item => item.seleccion === 'check_box');
        this.seleccionados = buscar.length;
        this.canales = [];
        if (this.seleccionados > 0) {
          this.usuario = {id: null};
          buscar.forEach((item) => {
            this.canales.push({canal: item.id, id_caso: item.mensaje.id_caso});
          });
        }
        if (buscar.length === 0) {
          this.icon = 'check_box_outline_blank';
        } else if (buscar.length === this.filtrados.length) {
          this.icon = 'check_box';
        } else {
          this.icon = 'indeterminate_check_box';
        }
      }
    },
    'filtro' () {
      this.conectados.forEach(item => {
        if ((!item.usuario || item.usuario.indexOf(this.filtro) === -1) &&
          (!item.persona || ((!item.persona.nombres || item.persona.nombres.indexOf(this.filtro) === -1) &&
          (!item.persona.primer_apellido || item.persona.primer_apellido.indexOf(this.flitro) === -1) &&
          (!item.persona.segundo_apellido || item.persona.segundo_apellido.indexOf(this.filtro) === -1)))) {
          item.seleccion = 'check_box_outline_blank';
        }
      });
      this.filtrados = [];
      this.filtrados = this.conectados.filter(item => (item.usuario && item.usuario.indexOf(this.filtro) > -1) || (item.persona && ((item.persona.nombres && item.persona.nombres.indexOf(this.filtro) > -1) || (item.persona.primer_apellido && item.persona.primer_apellido.indexOf(this.flitro) > -1) || (item.persona.segundo_apellido && item.persona.segundo_apellido.indexOf(this.filtro) > -1))));
      this.varios = !this.varios;
    }
  },
  methods: {
    imagenCanal (clasificacion) {
      let imagen = 'call.png';
      switch (clasificacion) {
        case 'whatsapp':
          imagen = 'wp.png';
          break;
        case 'facebook':
          imagen = 'fb.png';
          break;
        case 'twitter':
          imagen = 'tw.png';
          break;
        case 'correo':
          imagen = 'mail.png';
          break;
      }
      return require('@/assets/images/' + imagen);
    },
    seleccionarVarios () {
      if (this.filtro.length === 0) {
        let buscar = this.conectados.filter(item => item.seleccion === 'check_box');
        if (buscar.length === 0) {
          this.conectados.forEach((item) => {
            item.seleccion = 'check_box';
          });
        } else if (buscar.length === this.conectados.length) {
          this.conectados.forEach((item) => {
            item.seleccion = 'check_box_outline_blank';
          });
        } else {
          this.conectados.forEach((item) => {
            item.seleccion = 'check_box';
          });
        }
      } else {
        let buscar = this.filtrados.filter(item => item.seleccion === 'check_box');
        if (buscar.length === 0) {
          this.filtrados.forEach((item) => {
            item.seleccion = 'check_box';
          });
        } else if (buscar.length === this.filtrados.length) {
          this.filtrados.forEach((item) => {
            item.seleccion = 'check_box_outline_blank';
          });
        } else {
          this.filtrados.forEach((item) => {
            item.seleccion = 'check_box';
          });
        }
      }
      this.varios = !this.varios;
    },
    archivosSeleccionados (value) {
      this.archivos = value;
    },
    mensajeEnvio (value) {
      this.mensaje = value;
    },
    enviarMensaje (value) {
      this.exito = false;
      if (value === 'mensaje') {
        this.enviado = false;
        this.$loading.show('Enviando mensaje...');
        this.loading = true;
        this.$service.post(`system/operadores/enviar/mensaje/varios/`, { canales: this.canales, cubiculo: this.cubiculo.id, contenido: this.mensaje, tipo_contenido: 'texto', direccion: 'SALIDA' })
        .then(response => {
          this.loading = false;
          if (response) {
            this.$message.success(`Enviado exitosamente!`, null, { timeout: 2000 });
            this.mensaje = '';
            this.enviado = true;
            this.exito = true;
          } else {
            this.$message.error(`No se pudo enviar el mensaje!`, null, { timeout: 2000 });
            this.enviado = true;
          }
        });
      }
      if (value === 'archivos') {
        this.$confirm(`¿Está seguro de enviar archivos a los chats seleccionados?`, () => {
          this.enviado = false;
          this.$loading.show('Enviando documentos...');
          this.loading = true;
          this.$service.post(`system/operadores/enviar/mensaje/varios/`, { canales: this.canales, cubiculo: this.cubiculo.id, contenido: this.archivos, tipo_contenido: 'archivo', direccion: 'SALIDA' })
          .then(response => {
            this.loading = false;
            if (response) {
              this.$message.success(`Enviado exitosamente!`, null, { timeout: 2000 });
              this.mensaje = '';
              this.enviado = true;
              this.exito = true;
            } else {
              this.$message.error(`No se pudo enviar el mensaje!`, null, { timeout: 2000 });
              this.enviado = true;
            }
          });
        });
      }
    },
    abrirCanal (canalComunicacion) {
      this.canal_comunicacion_seleccionado = canalComunicacion.id;
      this.caso = {};
      this.caso.id_punto_atencion = this.$route.params.id;
      this.caso.clasificacion = 'llamada';
      this.dialogCasoKey = 'dialogCasoKey' + Math.random().toString(36).substr(2, 5);
      this.dialogCaso = true;
    },
    seleccionarCanal (item) {
      this.varios = !this.varios;
      item.seleccion = item.seleccion === 'check_box_outline_blank' ? 'check_box' : 'check_box_outline_blank';
    },
    cerrarCanal (key) {
      this.$confirm(`¿Está seguro de quitar el chat del listado?`, () => {
        let nuevo = [];
        for (let i = 0; i < this.conectados.length; i++) {
          if (i !== key) {
            nuevo.push(this.conectados[i]);
          }
        }
        this.conectados = nuevo;
        // this.ultima_conversacion = 0;
      });
    },
    textoCorto (texto) {
      if (texto.indexOf(';base64,') >= 0) texto = texto.split(';base64,')[0];
      return texto.substr(0, 32) + '...';
    },
    formato (fecha) {
      return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
    },
    recuperarPersona (value) {
      let buscar = this.conectados.find(item => item.id === this.usuario.id);
      if (buscar) {
        buscar.persona = value;
      }
    },
    iniciarConversacion (conectado) {
      this.varios = !this.varios;
      this.chatKey = Math.random().toString(36).substr(2, 5);
      this.usuario = conectado;
      let buscar = this.conectados.find(item => item.id === this.usuario.id);
      if (buscar) {
        buscar.mensaje.total = 0;
        this.usuario = buscar;
      }
    },
    recuperarPuntoAtencion () {
      this.$service.get(`system/operadores/cubiculo/${this.id}`, {})
      .then(response => {
        if (response) {
          this.cubiculo = response;
        }
      });
    },
    guardarCaso () {
      this.$loading.show('Abriendo caso...');
      this.loading = true;
      this.$service.post(`system/operadores/caso/crear`, {canal: this.canal_comunicacion_seleccionado, caso: this.caso})
      .then(response => {
        if (response) {
          this.caso = response;
          this.dialogCaso = false;
          if (this.caso.hasOwnProperty('punto_atencion_diferente') && this.caso.punto_atencion_diferente) {
            this.$message.warning(`El ciudadano tiene un CASO PENDIENTE en otro Punto de Atención!`, null, { timeout: 2000 });
            this.$confirm(`El ciudadano tiene un CASO PENDIENTE en otro Punto de Atención!<br>¿Desea ingresar a la conversación?`, () => {
              this.$router.push(`/conversacion/${this.caso.punto_atencion_diferente}/${this.caso.canal_entrada}`);
            });
          } else {
            if (this.caso.hasOwnProperty('caso_abierto') && this.caso.caso_abierto) {
              this.$message.success(`El mensaje se ha agregado a un CASO PENDIENTE del ciudadano!`, null, { timeout: 2000 });
            } else {
              this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
            }
          }
        }
      });
    },
    casoAdjuntado (value) {
      this.chatKey = Math.random().toString(36).substr(2, 5);
      this.usuario = {
        id: null
      };
      this.conectados = [];
      this.ultima_conversacion = 0;
    },
    casoDerivado (value) {
      this.chatKey = Math.random().toString(36).substr(2, 5);
      this.usuario = {
        id: null
      };
      this.conectados = [];
      this.ultima_conversacion = 0;
    }
  },
  updated () {
    var container = this.$el.querySelector('#conversation');
    if (container && container.scrollHeight && container.scrollTop) {
      container.scrollTop = container.scrollHeight;
    }
  },
  components: {socket, moment, ChatUsuario, Editor}
};
</script>
<style src="./chat.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/ChatOperador.vue